import { createSlice } from "@reduxjs/toolkit";


const sidebarSlice = createSlice({
    name: "sidebar",
    initialState: {
        sidebar: true,
    },
    reducers: {
        // eslint-disable-next-line
        toggleSidebar: (state, action) => {
            state.sidebar = !state.sidebar;
        },
    },
});

export const { toggleSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;